import { RouteInfo } from './sidebar.metadata';
export const ROUTES: RouteInfo[] = [
  {
    path: 'master-data',
    title: 'Table',
    icon: 'table_chart',
    image: '',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: 'dashboard/data',
    title: 'Data',
    icon: 'assessment',
    image: '',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: 'dashboard/acount',
    title: 'Acount',
    icon: 'assignment_ind',
    image: '',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: 'dashboard/role',
    title: 'Role',
    icon: 'fingerprint',
    image: '',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
];